enum QueueSettingEnum {
  Status = 0,
  Priority = 1,
  Tag = 2,
  Type = 3,
}
export { QueueSettingEnum };
